(function () {
  if (window.__moneyCounterSaleUk && window.__moneyCounterSaleUk.version === 3) return;
  function productSection() { return document.querySelector('[data-money-counter-module="products"]'); }
  function applyFilter(filter, scroll) {
    var section = productSection();
    if (!section) return;
    var cards = Array.from(section.querySelectorAll('[data-money-counter-product-card]'));
    var buttons = Array.from(section.querySelectorAll('[data-money-counter-filter]'));
    var count = 0;
    cards.forEach(function (card) { var show = filter === 'all' || card.dataset.moneyCounterCategory === filter; card.hidden = !show; if (show) count += 1; });
    buttons.forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.moneyCounterFilter === filter)); });
    var status = section.querySelector('[data-money-counter-filter-status]');
    if (status) status.textContent = count + (count === 1 ? ' model shown.' : ' models shown.');
    if (scroll) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function applyComparisonCategory(section, category) {
    if (!section) return;
    section.querySelectorAll('[data-compare-category]').forEach(function (button) {
      var active = button.dataset.compareCategory === category;
      button.setAttribute('aria-selected', String(active));
      button.tabIndex = active ? 0 : -1;
    });
    section.querySelectorAll('[data-compare-panel]').forEach(function (panel) { panel.hidden = panel.dataset.comparePanel !== category; });
  }
  function initReviewCarousel(carousel) {
    if (!carousel || carousel.__moneyCounterReviewCarousel) return;
    var viewport = carousel.querySelector('[data-review-viewport]');
    var track = carousel.querySelector('[data-review-track]');
    var items = Array.from(carousel.querySelectorAll('[data-review-item]'));
    var controls = carousel.closest('[data-money-counter-module="reviews"]').querySelector('[data-review-controls]');
    var previous = controls.querySelector('[data-review-prev]');
    var next = controls.querySelector('[data-review-next]');
    var status = carousel.querySelector('[data-review-status]');
    var index = 0;
    function visibleCount() {
      if (window.matchMedia('(max-width: 700px)').matches) return 1;
      if (window.matchMedia('(max-width: 990px)').matches) return 2;
      return 3;
    }
    function render(nextIndex, announce) {
      var visible = Math.min(visibleCount(), items.length);
      var maximum = Math.max(0, items.length - visible);
      index = Math.max(0, Math.min(nextIndex, maximum));
      var gap = parseFloat(window.getComputedStyle(track).columnGap) || 0;
      var cardWidth = items[0] ? items[0].getBoundingClientRect().width : 0;
      track.style.transform = 'translate3d(' + (-index * (cardWidth + gap)) + 'px, 0, 0)';
      controls.hidden = maximum === 0;
      previous.disabled = maximum === 0;
      next.disabled = maximum === 0;
      items.forEach(function (item, itemIndex) {
        var isVisible = itemIndex >= index && itemIndex < index + visible;
        item.setAttribute('aria-hidden', String(!isVisible));
        item.inert = !isVisible;
      });
      if (status && (announce || !status.textContent)) status.textContent = carousel.dataset.statusPrefix + ' ' + (items.length ? index + 1 : 0) + '-' + Math.min(index + visible, items.length) + ' of ' + items.length;
    }
    function move(direction) {
      var maximum = Math.max(0, items.length - visibleCount());
      var target = index + direction;
      if (target < 0) target = maximum;
      if (target > maximum) target = 0;
      render(target, true);
    }
    function reveal(item) {
      var itemIndex = items.indexOf(item);
      if (itemIndex >= 0) render(Math.min(itemIndex, Math.max(0, items.length - visibleCount())), true);
    }
    carousel.__moneyCounterReviewCarousel = { move: move, reveal: reveal, render: render };
    previous.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    new ResizeObserver(function () { render(index, false); }).observe(viewport);
    render(0, false);
  }
  function initReviewCarousels(root) {
    if (root.matches && root.matches('[data-review-carousel]')) initReviewCarousel(root);
    if (root.querySelectorAll) root.querySelectorAll('[data-review-carousel]').forEach(initReviewCarousel);
  }
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var filter = event.target.closest('[data-money-counter-filter]');
    if (filter) applyFilter(filter.dataset.moneyCounterFilter, false);
    var scene = event.target.closest('[data-money-counter-scene]');
    if (scene) applyFilter(scene.dataset.moneyCounterScene, true);
    var category = event.target.closest('[data-compare-category]');
    if (category) {
      var section = category.closest('[data-money-counter-module="comparison"]');
      applyComparisonCategory(section, category.dataset.compareCategory);
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    var reviewViewport = event.target.closest('[data-review-viewport]');
    if (reviewViewport) {
      var reviewCarousel = reviewViewport.closest('[data-review-carousel]');
      if (reviewCarousel.__moneyCounterReviewCarousel) reviewCarousel.__moneyCounterReviewCarousel.move(event.key === 'ArrowRight' ? 1 : -1);
      event.preventDefault();
      return;
    }
    var category = event.target.closest('[data-compare-category]');
    if (!category) return;
    var section = category.closest('[data-money-counter-module="comparison"]');
    var buttons = Array.from(section.querySelectorAll('[data-compare-category]'));
    var next = buttons[(buttons.indexOf(category) + (event.key === 'ArrowRight' ? 1 : buttons.length - 1)) % buttons.length];
    applyComparisonCategory(section, next.dataset.compareCategory);
    next.focus();
    event.preventDefault();
  });
  document.addEventListener('shopify:block:select', function (event) {
    var card = event.target.closest('[data-money-counter-product-card]');
    if (card) { applyFilter('all', false); card.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
    var comparisonBlock = event.target.closest('[data-compare-panel]');
    if (comparisonBlock) applyComparisonCategory(comparisonBlock.closest('[data-money-counter-module="comparison"]'), comparisonBlock.dataset.comparePanel);
    var reviewBlock = event.target.closest('[data-review-item]');
    if (reviewBlock) {
      var reviewCarousel = reviewBlock.closest('[data-review-carousel]');
      if (reviewCarousel.__moneyCounterReviewCarousel) reviewCarousel.__moneyCounterReviewCarousel.reveal(reviewBlock);
    }
  });
  document.addEventListener('shopify:section:load', function (event) { initReviewCarousels(event.target); });
  initReviewCarousels(document);
  window.__moneyCounterSaleUk = { version: 3, applyFilter: applyFilter, applyComparisonCategory: applyComparisonCategory, initReviewCarousels: initReviewCarousels };
})();
